<template>
  <div
      style="
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <div
        style="
        width: 95%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
      "
    >
      <div class="filters-actions-container">
        <div class="actions" style="align-self: flex-start">
          <v-btn
              height="48"
              width="200"
              variant="outlined"
              color="red"
              @click="showBloccaForm"
          >BLOCCA COLLO
          </v-btn
          >
        </div>
        <form @submit.prevent="reloadData" class="filters">
          <v-text-field
            density="comfortable"
            variant="outlined"
            label="CERCA UTENTE"
            append-inner-icon="mdi-magnify"
            hide-details
            style="width: 200px !important"
            v-model="searchingUtente.text"
            @input=""
          ></v-text-field>
          <div
              style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: end;
              row-gap: 5px;
            "
          >
            <v-dialog width="375px">
              <template v-slot:activator="{ props }">
                <v-btn
                    v-bind="props"
                    variant="outlined"
                    text="DATA BLOCCO"
                    height="48px"
                    width="200"
                ></v-btn>
              </template>
              <template v-slot:default="{ isActive }">
                <v-card title="SELEZIONA DATA BLOCCO">
                  <div
                      style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <v-date-picker
                        style="border: 1px solid #d0d0d0 !important"
                        v-model="this.dataBlocco"
                    ></v-date-picker>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text="CANCELLA"
                        @click="this.dataBlocco = null"
                        class="bg-red"
                        variant="outlined"
                    ></v-btn
                    >
                    <v-btn
                        text="INVIA"
                        @click="
                        () => {
                          reloadData();
                          isActive.value = false;
                        }
                      "
                        class="bg-green"
                        variant="outlined"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <small>{{ this.formatDate(this.dataBlocco) }}</small>
          </div>
          <v-text-field
              density="comfortable"
              variant="outlined"
              label="CERCA LDV"
              append-inner-icon="mdi-magnify"
              hide-details
              style="width: 200px !important"
              v-model="searchingCollo.text"
              @input=""
          ></v-text-field>
          <v-btn
            type="submit"
            icon="mdi-magnify"
            class="bg-blue"
            variant="outlined"
          />
          <v-btn
              variant="outlined"
              height="48"
              class="bg-red"
              @click="resetFiltri"
          >RESET FILTRI
          </v-btn>
        </form>
      </div>
    </div>
    <div style="width: 95%">
      <v-data-table-server
        :loading="loading"
        v-model:items-per-page-options="options"
        v-model:items-per-page="itemsPerPage"
        v-model:page="page"
        :items-length="totalItems"
        v-model:sort-by="sortBy"
        :fixed-header="true"
        :headers="headers"
        :items="this.colli"
        @update:options="fetchColliBloccati"
        style="
          width: 100%;
          border: 1px solid #d0d0d0;
          border-radius: 5px;
          max-height: 475px;
        "
      >
        <template v-slot:header.discordanze>
          <v-tooltip location="top" text="DISCORDANZE">
            <template v-slot:activator="{ props }">
              <span v-bind="props">DIS.</span>
            </template>
          </v-tooltip>
        </template>
        <template v-slot:item.discordanze="{ item }">
          <v-chip v-if="item.discordanze != 0" color="red" variant="flat">
            {{ item.discordanze }}
          </v-chip>
          <v-chip v-else color="green" variant="flat">
            {{ item.discordanze }}
          </v-chip>
        </template>
        <template v-slot:item.emailAggiornatore="{ item }">
          <p
              v-if="
              item.emailAggiornatore === null ||
              item.emailAggiornatore === 'null'
            "
          >
            NESSUNO
          </p>
          <p v-else>{{ item.emailAggiornatore }}</p>
        </template>
        <template v-slot:item.data_creazione="{ item }">
          {{ this.formattaDataOra(item.data_creazione) }}
        </template>
        <template v-slot:item.data_aggiornamento="{ item }">
          <p
              v-if="
              item.data_aggiornamento === null ||
              item.data_aggiornamento === 'null'
            "
          >
            NESSUNO
          </p>
          <p v-else>{{ this.formattaDataOra(item.data_aggiornamento) }}</p>
        </template>
        <template v-slot:item.note="{ item }">
          <v-btn
            icon="mdi-pencil"
            variant="text"
            size="small"
            @click="openEditNote(item)"
          />
        </template>
        <template v-slot:item.id="{ item }">
          <v-btn variant="outlined" @click="showSbloccaConfirm(item)"
          >SBLOCCA
          </v-btn
          >
        </template>
      </v-data-table-server>
    </div>
    <v-dialog v-model="dialogEditNote" max-width="500px">
      <v-card title="MODIFICA NOTE">
        <v-card-text>
          <NoteColloFields
            v-model:note="editingNote"
            :note-ristampa="editingNoteRistampa"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="dialogEditNote = false">CHIUDI</v-btn>
          <v-btn variant="outlined" class="bg-green" @click="saveNote">SALVA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {Icon} from "@iconify/vue";
import NoteColloFields from "./NoteColloFields.vue";
const axios = require("axios");
import Swal from "sweetalert2";
const {DateTime} = require("luxon");

export default {
  name: "ColliBloccatiTable",

  setup() {
    const store = useStore();
    return {
      store,
      dateTime: DateTime,
    };
  },

  components: {
    Icon,
    NoteColloFields,
  },

  data() {
    return {
      colli: [],
      searchingUtente: {
        text: "",
      },
      sortBy: [{key: "data_creazione", order: "desc"}],
      headers: [
        {title: "CODICE COLLO", value: "ldv", sortable: true},
        {title: "DATA BLOCCO", value: "data_creazione", sortable: true},
        {title: "DISCORDANZE", value: "discordanze", sortable: false},
        {
          title: "N° PEZZI",
          value: "numeroPezzi",
          sortable: false,
          align: "center",
        },
        {title: "STATO", value: "stato", sortable: false},
        {
          title: "ULTIMO AGGIORNAMENTO",
          value: "data_aggiornamento",
          sortable: false,
        },
        {
          title: "AUTORE AGGIORNAMENTO",
          value: "emailAggiornatore",
          sortable: false,
        },
        {title: "NOTE", value: "note", sortable: false},
        {title: "", value: "id", sortable: false},
      ],
      searchingCollo: {
        text: "",
      },
      loading: true,
      dialogEditNote: false,
      editingCollo: null,
      editingNote: "",
      editingNoteRistampa: "",
      dataBlocco: null,
      options: [10, 20, 30, 40, 50],
      itemsPerPage: 10,
      totalItems: 0,
      page: 1,
    };
  },

  methods: {
    backendMessage(error) {
      const data = error?.response?.data;
      return typeof data === "string" && data.length > 0 && data.length < 500
        ? data
        : null;
    },
    async fetchColliBloccati() {
      this.loading = true;
      const apiUrl = `${this.$apiBaseUrl}/colli/findCollibloccati`;
      const bearerToken = this.$keycloak.token;
      console.log(bearerToken);

      const config = {
        headers: {
          'Authorization': `Bearer ${bearerToken}`,
        },
      };

      let filters = {
        userMail:
          this.searchingUtente.text.trim().toLowerCase() == ""
            ? null
            : this.searchingUtente.text.trim().toLowerCase(),
        ldv: this.searchingCollo.text.trim() == "" ? null : this.searchingCollo.text.trim(),
        dataBlocco: this.dataBlocco == null
            ? null
            : DateTime.fromJSDate(this.dataBlocco)
                .setZone("Europe/Rome")
                .toFormat("yyyy-MM-dd"),
      }

      let urlParams = {
        filtro: filters,
        sortBy: this.sortBy[0],
        page: this.page - 1,
        itemsPage: this.itemsPerPage,
      }

      try {
        const response = await axios.post(apiUrl, urlParams, config);
        console.log('Response:', response.data);
        this.totalItems = response.data.length;
        this.colli = response.data.colliViewList
        this.loading = false;
      } catch (error) {
        console.error('Error:', error.message);
        Swal.fire({
          title: "ERRORE",
          text: this.backendMessage(error) ?? `C'è stato un errore nel caricamento dei colli bloccati`,
          icon: "error",
        });
      }
    },
    reloadData() {
      this.loading = true;
      this.fetchColliBloccati();
    },
    resetFiltri() {
      this.searchingCollo.text = "";
      this.searchingUtente.text = "";
      this.dataBlocco = null;
      this.reloadData();
    },
    showSbloccaConfirm(collo) {
      this.store.dispatch("changeBodyClass", "formOpen");
      this.store.dispatch("showSbloccaColloConfirm", collo);
    },
    openEditNote(collo) {
      this.editingCollo = collo;
      this.editingNote = collo.note || "";
      this.editingNoteRistampa = collo.noteRistampa || "";
      this.dialogEditNote = true;
    },
    async saveNote() {
      const apiUrl = `${this.$apiBaseUrl}/colli/`;
      const bearerToken = this.$keycloak.token;
      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      };
      const colloModifica = {
        ldv: this.editingCollo.ldv,
        stato: this.editingCollo.stato,
        createDate: new Date(),
        bloccato: this.editingCollo.bloccato,
        note: this.editingNote,
      };
      try {
        await axios.put(apiUrl, colloModifica, config);
        this.dialogEditNote = false;
        Swal.fire({
          title: "NOTE MODIFICATE",
          text: `Le note del collo ${this.editingCollo.ldv} sono state modificate.`,
          icon: "success",
        });
        this.fetchColliBloccati();
      } catch (error) {
        console.error("Error:", error.message);
        Swal.fire({
          title: "ERRORE",
          text: this.backendMessage(error) ?? `C'è stato un errore nella modifica delle note`,
          icon: "error",
        });
      }
    },
    showBloccaForm() {
      this.store.dispatch("changeBodyClass", "formOpen");
      this.store.dispatch("showBloccaColloForm");
    },
    formatDate(inputDate) { 
      if (inputDate === null) {
        return "nessuna data selezionata";
      } else {
        // Parse the input date string
        const date = new Date(inputDate);

        // Get day, month, and year components
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
        const year = date.getFullYear();

        // Construct the formatted date string
        const formattedDate = `${day} / ${month} / ${year}`;

        return formattedDate;
      }
    },
    formattaDataOra(date) {
      return this.dateTime
          .fromISO(date + "Z")
          .setZone("Europe/Rome")
          .setLocale("it")
          .toFormat("dd/MM/yyyy | HH:mm:ss");
    },
  },

  watch: {},
};
</script>

<style scoped>
.filters-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 10px;
  width: fit-content;
}

.v-btn--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.v-text-field--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.v-field--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.user-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.v-card-title {
  font-size: 2rem;
}

.warning-text {
  font-size: 1.2rem;
  text-align: center;
  width: 400px;
}
</style>
